var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.99997V9.08831C14 9.61331 14.63 9.86997 14.9916 9.49664L18.2466 6.24164C18.48 6.00831 18.48 5.64664 18.2466 5.41331L14.9916 2.15831C14.9094 2.07769 14.8051 2.02322 14.692 2.00176C14.5788 1.9803 14.4618 1.99282 14.3558 2.03774C14.2497 2.08265 14.1594 2.15795 14.096 2.25415C14.0327 2.35035 13.9993 2.46314 14 2.57831V4.66664C8.84329 4.66664 4.66663 8.84331 4.66663 14C4.66663 15.2133 4.89996 16.38 5.33163 17.4416C5.64663 18.2233 6.64996 18.4333 7.24496 17.8383C7.55996 17.5233 7.68829 17.045 7.51329 16.625C7.17496 15.82 6.99996 14.9216 6.99996 14C6.99996 10.1383 10.1383 6.99997 14 6.99997ZM20.755 10.1616C20.44 10.4766 20.3116 10.9666 20.4866 11.375C20.8133 12.1916 21 13.0783 21 14C21 17.8616 17.8616 21 14 21V18.9116C14 18.3866 13.37 18.13 13.0083 18.5033L9.75329 21.7583C9.51996 21.9916 9.51996 22.3533 9.75329 22.5866L13.0083 25.8416C13.0898 25.9216 13.193 25.9758 13.3051 25.9977C13.4172 26.0195 13.5332 26.008 13.6388 25.9645C13.7444 25.921 13.8349 25.8475 13.8991 25.7531C13.9633 25.6587 13.9984 25.5475 14 25.4333V23.3333C19.1566 23.3333 23.3333 19.1566 23.3333 14C23.3333 12.7866 23.1 11.62 22.6683 10.5583C22.3533 9.77664 21.35 9.56664 20.755 10.1616Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3666 11.1667H16.0332M12.3666 12.7407H16.0332M14.9639 16.8333L12.3666 14.3147H13.2832C15.3202 14.3147 15.3202 11.1667 13.2832 11.1667",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceSubscription);
export default __webpack_public_path__ + "static/media/device-subscription.2b153ed01835aa0fc0484aad5e52a522.svg";
export { ForwardRef as ReactComponent };